/**
 * <ImportDataTable 
 *		// please describe props here
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import locale from './locale';
import './ImportDataTable.scss';

const GENDER = ['Male', 'Female', 'Other', 'None'];

class ImportDataTable extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);
  }

  componentWillMount() {

  }
  
  render() {
    const { data, fields, theads, errors, filename } = this.props;

    let errorNum = 0;

    _.each(errors, (err)=>{
      if (err) {
        errorNum += Object.keys(err).length;
      }
    });
    
    const rowNum = data.length;

    const hasError = errorNum > 0; 

    return (
      <div className='ImportDataTable'>
        { hasError && <div className='errorNotice'><i className='fa icon-attention-circled'></i>  {__('Your import, file {filename} has {rowNum} rows, and {errorNum} errors.', locale, {filename, rowNum, errorNum})}</div> }
        <div className='TableWrapper'>
          <table>
            <thead>
              <tr>
                <th></th>
                {theads.map(({ label, required }, key)=>{
                  return <th key={key}>{label} { required &&<span className='required'>*</span> }</th>
                })}
              </tr>
            </thead>
            <tbody>
              {data.map((tr, trIdx)=>{
                const error = errors[trIdx];
                return (
                  <tr key={trIdx} className={classnames({ hasError: typeof error !== 'undefined' })}>
                    <td className='trIndex'>{trIdx + 1}</td>
                    { tr.map((td, tdIdx)=>{ 
                        const keyName = fields[tdIdx];
                        let hasError = false;
                      
                        if (error && error[keyName]) {
                          hasError = true;
                        }

                        if (keyName === 'gender') {
                          td = __(GENDER[td], locale);
                        } 

                        return <td key={tdIdx} className={classnames({ hasError })}>{td}</td>
                      }) 
                    }
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

export default ImportDataTable;



// WEBPACK FOOTER //
// ./src/containers/pages/ImportStudent/ImportDataTable.js